<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<!-- Collapsed state -->
<div class="filter-panel-collapsed" *ngIf="!isOpen" (click)="togglePanel()">
  <fa-icon
    class="icon filter-toggle-icon"
    [icon]="faChevronDoubleRight"
    aria-label="expand filter"
  ></fa-icon>
  <span
    class="filter_text filter-text-vertical"
    i18n="title on collapsed filter panel@@filterUpperCase"
    >FILTER</span
  >
</div>
<!-- Expanded state -->
<div class="filter-panel" *ngIf="isOpen">
  <div class="filter_header">
    <!-- Title is passed dynamically from parent component. Add i18n via $localize in parent .ts file -->
    <span class="filter_text">{{ title }}</span>
    <span class="expand"></span>
    <button mat-icon-button aria-label="collapse filter" (click)="togglePanel()">
      <fa-icon
        class="icon filter-close-icon"
        [icon]="faArrowDownLeftAndArrowUpRightToCenter"
        aria-label="close"
      ></fa-icon>
    </button>
  </div>

  <!-- Scrollable content area for projected filter fields -->
  <div class="filter_scroll_container">
    <ng-content></ng-content>
  </div>

  <!-- Reset footer -->
  <div class="filter_reset_footer">
    <button mat-button class="reset-button" [disabled]="resetDisabled" (click)="onReset()">
      <fa-icon class="icon" [icon]="faUndo" aria-label="reset"></fa-icon>
      <span i18n="reset filter button@@resetFilter">Reset filter</span>
    </button>
  </div>
</div>
